import React from 'react';
import { ContactCaptureListView } from '../components';
export const ContactCaptureListPage = () => <ContactCaptureListView />;
